import { ApiError } from './client';

/** Codes serveur signalant qu'une action est bloquée par le plan d'abonnement. */
const UPGRADE_CODES = ['feature_unavailable', 'quota_exceeded', 'quota'] as const;

/** Vrai si l'erreur vient d'une fonctionnalité absente du plan ou d'un quota atteint (403/402/429 avec code dédié). */
/** Code serveur (HTTP 402) : le plan effectif est free, la console exige d'abord le choix d'une offre. */
export const SUBSCRIPTION_REQUIRED = 'subscription_required';

/** Vrai si le serveur refuse l'usage de la console faute d'offre choisie (essai ou plan payant). */
export function isSubscriptionRequired(e: unknown): e is ApiError {
  return e instanceof ApiError && e.code === SUBSCRIPTION_REQUIRED;
}

export function isUpgradeError(e: unknown): e is ApiError {
  return e instanceof ApiError && (UPGRADE_CODES as readonly string[]).includes(e.code);
}
